(function () {
  var STORAGE_PREFIX = 'saway:wishlist:ring-size:';
  var RING_PROPERTY_NAME = 'Yüzük Ölçüsü';
  var DEFAULT_RING_SIZE = '8';
  var CART_MINI_SECTION_ID = 'xo-cart-mini';
  var ADD_TO_CART_SELECTOR = '.xb-list-style__add-to-cart';
  var SIZE_GUIDE_QUERY = 'saway_size_guide';
  var SIZE_GUIDE_TRIGGER_SELECTOR = 'xo-modal-trigger[xo-name="show-sizeguide"]';
  var PRODUCT_PATH_RE = /\/products\/([^/?#]+)/;
  var productCache = {};

  function getHandleFromUrl(url) {
    var match = String(url || '').match(PRODUCT_PATH_RE);
    return match ? match[1] : '';
  }

  function normalizeText(value) {
    return String(value || '').toLocaleLowerCase('tr-TR').replace(/ü/g, 'u');
  }

  function isRingText(value) {
    var normalized = normalizeText(value);
    return normalized.indexOf('yuzuk') !== -1 || normalized.indexOf('ring') !== -1;
  }

  function getShopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function joinRoot(path) {
    return getShopifyRoot().replace(/\/$/, '/') + path.replace(/^\//, '');
  }

  function readStore(handle) {
    if (!handle || !window.localStorage) return null;
    try {
      var raw = window.localStorage.getItem(STORAGE_PREFIX + handle);
      return raw ? normalizeRingPayload(JSON.parse(raw)) : null;
    } catch (error) {
      return null;
    }
  }

  function writeStore(handle, payload) {
    if (!handle || !window.localStorage || !payload || !payload.size) return;
    try {
      window.localStorage.setItem(STORAGE_PREFIX + handle, JSON.stringify(normalizeRingPayload(payload)));
    } catch (error) {}
  }

  function normalizeRingPayload(payload) {
    if (!payload || !payload.size) return payload;

    if (typeof payload.confirmed === 'undefined') {
      payload.confirmed = String(payload.size) !== DEFAULT_RING_SIZE;
    }

    return payload;
  }

  function isRingPayloadConfirmed(payload) {
    return !!(payload && payload.confirmed);
  }

  function markRingSelectTouched(select) {
    if (select) {
      select.setAttribute('data-saway-ring-size-touched', 'true');
    }
  }

  function isRingSelectTouched(select) {
    return !!(
      select &&
      (select.getAttribute('data-saway-ring-size-touched') === 'true' || String(select.value) !== DEFAULT_RING_SIZE)
    );
  }

  function getRingSizeForButton(button) {
    if (!button) return null;
    var productId = button.getAttribute('xb-product-id');
    var handle = button.getAttribute('xb-product-handle') || getHandleFromUrl(location.pathname);
    var title = button.getAttribute('xb-product-title') || '';
    var selector = productId
      ? '[data-ring-size-property-select][data-product-id="' + productId + '"]'
      : '[data-ring-size-property-select]';
    var select = document.querySelector(selector);

    if (!select || !select.value) {
      if (!isRingText(title)) return null;

      return {
        size: button.getAttribute('data-saway-ring-size') || DEFAULT_RING_SIZE,
        confirmed: false,
        handle: handle,
        productId: productId,
        variantId: button.getAttribute('xb-product-variant') || '',
        title: title,
      };
    }

    return {
      size: select.value,
      confirmed: isRingSelectTouched(select),
      handle: handle,
      productId: productId,
      variantId: button.getAttribute('xb-product-variant') || '',
      title: title,
    };
  }

  function rememberRingSize(button) {
    var payload = getRingSizeForButton(button);
    if (!payload || !payload.handle) return;

    button.setAttribute('data-saway-ring-size', payload.size);
    writeStore(payload.handle, payload);
  }

  function getRowHandle(row) {
    var link = row && row.querySelector('a[href*="/products/"]');
    return link ? getHandleFromUrl(link.getAttribute('href')) : '';
  }

  function getRowTitle(row) {
    var title = row && row.querySelector('.xb-list-style__product-title');
    return title ? title.textContent.trim() : '';
  }

  function getRowRingPayload(row) {
    var handle = getRowHandle(row);
    var payload = readStore(handle);

    if (payload && payload.size) return payload;
    if (!isRingText(getRowTitle(row))) return null;

    payload = {
      size: row.getAttribute('data-saway-ring-size') || DEFAULT_RING_SIZE,
      confirmed: false,
      handle: handle,
      productId: '',
      variantId: row.getAttribute('data-saway-ring-variant-id') || '',
      title: getRowTitle(row),
    };

    writeStore(handle, payload);
    return payload;
  }

  function annotateWishlistRow(row) {
    if (!row) return;

    var handle = getRowHandle(row);
    var payload = readStore(handle) || getRowRingPayload(row);

    if (!payload || !payload.size) return;

    var wrapper = row.querySelector('.xb-list-style__variant-wrapper');
    if (!wrapper) return;

    var text = isRingPayloadConfirmed(payload) ? 'Yüzük Ölçüsü: ' + payload.size : 'Yüzük ölçüsü seçilmedi';
    var existing = wrapper.querySelector('.saway-wishlist-ring-size');
    if (existing && existing.textContent === text) return;

    var size = existing || document.createElement('div');
    size.className = 'saway-wishlist-ring-size';
    size.textContent = text;

    if (!existing) {
      wrapper.insertBefore(size, wrapper.firstChild);
    }

    row.setAttribute('data-saway-ring-annotated', 'true');
    row.setAttribute('data-saway-ring-size', payload.size);
    row.setAttribute('data-saway-ring-confirmed', isRingPayloadConfirmed(payload) ? 'true' : 'false');
    row.setAttribute('data-saway-ring-variant-id', payload.variantId || '');
  }

  function annotateWishlistModal() {
    document.querySelectorAll('.xb-list-style__tbody tr').forEach(annotateWishlistRow);
  }

  function setRowStatus(row, type, message) {
    if (!row) return;

    var productInfo = row.querySelector('.xb-list-style__product-info');
    var variantWrapper = row.querySelector('.xb-list-style__variant-wrapper');
    var wrapper = productInfo || variantWrapper;
    if (!wrapper) return;

    var status = row.querySelector('.saway-wishlist-cart-status');
    if (!status) {
      status = document.createElement('div');
      status.className = 'saway-wishlist-cart-status';

      if (productInfo && variantWrapper && variantWrapper.parentNode === productInfo) {
        variantWrapper.insertAdjacentElement('afterend', status);
      } else {
        wrapper.appendChild(status);
      }
    }

    status.classList.remove('saway-wishlist-cart-status--success', 'saway-wishlist-cart-status--error');
    status.classList.add('saway-wishlist-cart-status--' + type);
    status.textContent = message;
  }

  function clearRowStatus(row) {
    var status = row && row.querySelector('.saway-wishlist-cart-status');
    if (status) status.textContent = '';
  }

  function setRowSizeConfirmOpen(row, isOpen) {
    if (!row) return;
    row.classList.toggle('saway-wishlist-size-confirm-open', !!isOpen);
  }

  function setRowButtons(row, state, text) {
    if (!row) return;

    row.querySelectorAll(ADD_TO_CART_SELECTOR).forEach(function (button) {
      if (!button.getAttribute('data-saway-original-text')) {
        button.setAttribute('data-saway-original-text', button.textContent.trim() || 'Sepete Ekle');
      }

      button.disabled = state === 'loading';
      button.classList.toggle('saway-wishlist-add-to-cart--loading', state === 'loading');
      button.classList.toggle('saway-wishlist-add-to-cart--success', state === 'success');
      button.textContent = text || button.getAttribute('data-saway-original-text');
    });
  }

  function createSizeButton(size, selectedSize) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'saway-wishlist-size-confirm__choice';
    button.setAttribute('data-saway-size-choice', String(size));
    button.textContent = String(size);

    if (String(size) === String(selectedSize)) {
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
    } else {
      button.setAttribute('aria-pressed', 'false');
    }

    return button;
  }

  function getSizeConfirmationPanel(row) {
    return row ? row.querySelector('.saway-wishlist-size-confirm') : null;
  }

  function getSizeGuideUrl(row) {
    var handle = getRowHandle(row);
    return handle ? joinRoot('products/' + encodeURIComponent(handle) + '?' + SIZE_GUIDE_QUERY + '=1') : '#';
  }

  function openProductSizeGuide() {
    var trigger = document.querySelector(SIZE_GUIDE_TRIGGER_SELECTOR);
    if (!trigger) return false;

    trigger.click();
    return true;
  }

  function openProductSizeGuideFromUrl() {
    var shouldOpen = false;

    try {
      shouldOpen = new URLSearchParams(window.location.search).has(SIZE_GUIDE_QUERY);
    } catch (error) {}

    if (!shouldOpen) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (openProductSizeGuide() || attempts >= 12) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  function syncSizeConfirmationSelection(panel, size) {
    if (!panel) return;

    panel.setAttribute('data-saway-selected-size', String(size));
    panel.querySelectorAll('[data-saway-size-choice]').forEach(function (button) {
      var isSelected = button.getAttribute('data-saway-size-choice') === String(size);
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function showRingSizeConfirmation(row, payload) {
    if (!row || !payload) return;

    document.querySelectorAll('.saway-wishlist-size-confirm').forEach(function (panel) {
      if (!row.contains(panel)) {
        setRowSizeConfirmOpen(panel.closest('.xb-list-style__tbody tr'), false);
        panel.remove();
      }
    });

    var wrapper = row.querySelector('.xb-list-style__variant-wrapper') || row.querySelector('.xb-list-style__product-info');
    if (!wrapper) return;

    var panel = getSizeConfirmationPanel(row);
    var selectedSize = payload.size || DEFAULT_RING_SIZE;

    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'saway-wishlist-size-confirm';
      panel.setAttribute('data-saway-selected-size', selectedSize);

      var title = document.createElement('div');
      title.className = 'saway-wishlist-size-confirm__title';
      title.textContent = 'Yüzük ölçünüzü seçin';

      var copy = document.createElement('div');
      copy.className = 'saway-wishlist-size-confirm__copy';
      copy.textContent = 'Sepete eklemeden önce ölçüyü onaylayın.';

      var choices = document.createElement('div');
      choices.className = 'saway-wishlist-size-confirm__choices';
      for (var size = 8; size <= 21; size += 1) {
        choices.appendChild(createSizeButton(size, selectedSize));
      }

      var guide = document.createElement('a');
      guide.className = 'saway-wishlist-size-confirm__guide';
      guide.href = getSizeGuideUrl(row);
      guide.setAttribute('data-saway-size-guide', '');
      guide.textContent = 'Ölçü rehberini aç';

      var actions = document.createElement('div');
      actions.className = 'saway-wishlist-size-confirm__actions';

      var submit = document.createElement('button');
      submit.type = 'button';
      submit.className = 'saway-wishlist-size-confirm__submit';
      submit.setAttribute('data-saway-size-confirm-add', '');
      submit.textContent = 'Sepete Ekle';

      var cancel = document.createElement('button');
      cancel.type = 'button';
      cancel.className = 'saway-wishlist-size-confirm__cancel';
      cancel.setAttribute('data-saway-size-confirm-cancel', '');
      cancel.textContent = 'Vazgeç';

      actions.appendChild(submit);
      actions.appendChild(cancel);

      panel.appendChild(title);
      panel.appendChild(copy);
      panel.appendChild(choices);
      panel.appendChild(guide);
      panel.appendChild(actions);
      wrapper.appendChild(panel);
    }

    var guideLink = panel.querySelector('[data-saway-size-guide]');
    if (guideLink) guideLink.href = getSizeGuideUrl(row);

    syncSizeConfirmationSelection(panel, selectedSize);
    setRowSizeConfirmOpen(row, true);
    clearRowStatus(row);
  }

  function confirmRowRingSize(row, size) {
    var handle = getRowHandle(row);
    var current = getRowRingPayload(row) || {};
    var payload = normalizeRingPayload({
      size: String(size || DEFAULT_RING_SIZE),
      confirmed: true,
      handle: handle,
      productId: current.productId || '',
      variantId: current.variantId || row.getAttribute('data-saway-ring-variant-id') || '',
      title: current.title || getRowTitle(row),
    });

    writeStore(handle, payload);
    row.setAttribute('data-saway-ring-size', payload.size);
    row.setAttribute('data-saway-ring-confirmed', 'true');
    annotateWishlistRow(row);
    clearRowStatus(row);

    return payload;
  }

  function resetRowButtons(row) {
    window.setTimeout(function () {
      if (!row) return;

      row.querySelectorAll(ADD_TO_CART_SELECTOR).forEach(function (button) {
        button.disabled = false;
        button.classList.remove('saway-wishlist-add-to-cart--loading', 'saway-wishlist-add-to-cart--success');
        button.textContent = button.getAttribute('data-saway-original-text') || 'Sepete Ekle';
      });
    }, 2200);
  }

  function getProductData(handle) {
    if (!handle) return Promise.reject(new Error('Ürün bulunamadı.'));
    if (productCache[handle]) return productCache[handle];

    productCache[handle] = fetch(joinRoot('products/' + encodeURIComponent(handle) + '.js'), {
      cache: 'no-store',
      credentials: 'same-origin',
    }).then(function (response) {
      if (!response.ok) throw new Error('Ürün bilgisi alınamadı.');
      return response.json();
    });

    return productCache[handle];
  }

  function getVariantIdForRow(row) {
    var payload = getRowRingPayload(row);
    if (payload && payload.variantId) return Promise.resolve(payload.variantId);

    var handle = getRowHandle(row);
    return getProductData(handle).then(function (product) {
      var variants = product && product.variants ? product.variants : [];
      var variant = variants.find(function (item) {
        return item && item.available;
      }) || variants[0];

      if (!variant || !variant.id) throw new Error('Ürün varyantı bulunamadı.');
      return variant.id;
    });
  }

  function updateCartSize(itemCount) {
    document.querySelectorAll('xo-cart-size').forEach(function (el) {
      el.textContent = itemCount;
    });
  }

  function replaceCartMini(sectionHtml) {
    if (!sectionHtml) return;

    var currentCartMini = document.querySelector('xo-cart-mini#' + CART_MINI_SECTION_ID);
    if (!currentCartMini) return;

    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var nextCartMini = parsed.querySelector('xo-cart-mini#' + CART_MINI_SECTION_ID);

    if (nextCartMini) {
      currentCartMini.innerHTML = nextCartMini.innerHTML;
    }
  }

  function syncXoCartStore(cart, sectionHtml) {
    if (!window.xoStore || typeof window.xoStore.set !== 'function') return;

    try {
      window.xoStore.set('xo-cart', function (state) {
        var sections = Object.assign({}, state && state.sections ? state.sections : {});

        if (sectionHtml) {
          sections[CART_MINI_SECTION_ID] = sectionHtml;
        }

        return Object.assign({}, state, {
          size: cart && cart.item_count ? cart.item_count : 0,
          sections: sections,
          changeLineLoading: -1,
        });
      })('wishlist/add-to-cart');
    } catch (error) {}
  }

  function refreshCartState() {
    return Promise.all([
      fetch(joinRoot('cart.js'), { cache: 'no-store', credentials: 'same-origin' }).then(function (response) {
        return response.json();
      }),
      fetch(joinRoot('?sections=' + CART_MINI_SECTION_ID), { cache: 'no-store', credentials: 'same-origin' }).then(function (response) {
        return response.json();
      }),
    ]).then(function (responses) {
      var cart = responses[0] || {};
      var sections = responses[1] || {};
      var sectionHtml = sections[CART_MINI_SECTION_ID];

      updateCartSize(cart.item_count || 0);
      replaceCartMini(sectionHtml);
      syncXoCartStore(cart, sectionHtml);

      document.dispatchEvent(
        new CustomEvent('saway:cart-refreshed', {
          detail: { cart: cart, sections: sections },
        })
      );

      return cart;
    });
  }

  function addWishlistRowToCart(row) {
    var ringPayload = getRowRingPayload(row);

    return getVariantIdForRow(row).then(function (variantId) {
      var line = {
        id: Number(variantId),
        quantity: 1,
      };

      if (ringPayload && ringPayload.size) {
        line.properties = {};
        line.properties[RING_PROPERTY_NAME] = ringPayload.size;
      }

      return fetch(joinRoot('cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(line),
      }).then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) {
            throw new Error(json && (json.description || json.message) ? json.description || json.message : 'Sepete eklenemedi.');
          }

          return json;
        });
      });
    });
  }

  function handleWishlistAddToCart(event) {
    var button = event.target && event.target.closest ? event.target.closest(ADD_TO_CART_SELECTOR) : null;
    if (!button) return;

    var row = button.closest('.xb-list-style__tbody tr');
    if (!row) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (button.disabled) return;

    var ringPayload = getRowRingPayload(row);
    if (ringPayload && !isRingPayloadConfirmed(ringPayload)) {
      showRingSizeConfirmation(row, ringPayload);
      return;
    }

    setRowSizeConfirmOpen(row, false);
    setRowButtons(row, 'loading', 'Ekleniyor');
    clearRowStatus(row);

    addWishlistRowToCart(row)
      .then(refreshCartState)
      .then(function () {
        setRowButtons(row, 'success', 'Eklendi');
        setRowStatus(row, 'success', 'Sepete eklendi.');
        resetRowButtons(row);
      })
      .catch(function (error) {
        setRowButtons(row, 'idle');
        setRowStatus(row, 'error', error && error.message ? error.message : 'Sepete eklenemedi.');
      });
  }

  function handleSizeConfirmationClick(event) {
    var choice = event.target && event.target.closest ? event.target.closest('[data-saway-size-choice]') : null;
    var submit = event.target && event.target.closest ? event.target.closest('[data-saway-size-confirm-add]') : null;
    var cancel = event.target && event.target.closest ? event.target.closest('[data-saway-size-confirm-cancel]') : null;
    if (!choice && !submit && !cancel) return;

    var row = event.target.closest('.xb-list-style__tbody tr');
    if (!row) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var panel = getSizeConfirmationPanel(row);

    if (choice) {
      syncSizeConfirmationSelection(panel, choice.getAttribute('data-saway-size-choice'));
      return;
    }

    if (cancel) {
      if (panel) panel.remove();
      setRowSizeConfirmOpen(row, false);
      clearRowStatus(row);
      return;
    }

    var selectedSize = panel ? panel.getAttribute('data-saway-selected-size') : DEFAULT_RING_SIZE;
    confirmRowRingSize(row, selectedSize);
    setRowButtons(row, 'loading', 'Ekleniyor');

    addWishlistRowToCart(row)
      .then(refreshCartState)
      .then(function () {
        if (panel) panel.remove();
        setRowSizeConfirmOpen(row, false);
        setRowButtons(row, 'success', 'Eklendi');
        setRowStatus(row, 'success', 'Sepete eklendi.');
        resetRowButtons(row);
      })
      .catch(function (error) {
        setRowButtons(row, 'idle');
        setRowStatus(row, 'error', error && error.message ? error.message : 'Sepete eklenemedi.');
      });
  }

  function handleSizeGuideClick(event) {
    var guide = event.target && event.target.closest ? event.target.closest('[data-saway-size-guide]') : null;
    if (!guide || !openProductSizeGuide()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target && event.target.closest ? event.target.closest('.xb-wishlist__add') : null;
      if (button) {
        rememberRingSize(button);
      }
    },
    true
  );

  document.addEventListener('click', handleWishlistAddToCart, true);
  document.addEventListener('click', handleSizeConfirmationClick, true);
  document.addEventListener('click', handleSizeGuideClick, true);

  document.addEventListener(
    'pointerdown',
    function (event) {
      var select = event.target && event.target.closest ? event.target.closest('[data-ring-size-property-select]') : null;
      if (select) markRingSelectTouched(select);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      var select = event.target && event.target.closest ? event.target.closest('[data-ring-size-property-select]') : null;
      if (select) markRingSelectTouched(select);
    },
    true
  );

  document.addEventListener('change', function (event) {
    var select = event.target && event.target.closest ? event.target.closest('[data-ring-size-property-select]') : null;
    if (!select) return;

    markRingSelectTouched(select);

    var productId = select.getAttribute('data-product-id');
    document
      .querySelectorAll('.xb-wishlist__add[xb-product-id="' + productId + '"]')
      .forEach(function (button) {
        var handle = button.getAttribute('xb-product-handle') || getHandleFromUrl(location.pathname);
        button.setAttribute('data-saway-ring-size', select.value);
        writeStore(handle, {
          size: select.value,
          confirmed: true,
          handle: handle,
          productId: productId,
          variantId: button.getAttribute('xb-product-variant') || '',
          title: button.getAttribute('xb-product-title') || '',
        });
      });
  });

  var observer = new MutationObserver(annotateWishlistModal);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      annotateWishlistModal();
      openProductSizeGuideFromUrl();
    });
  } else {
    annotateWishlistModal();
    openProductSizeGuideFromUrl();
  }
})();
